import React from 'react';
import { Link } from 'react-router-dom';
import { LogoMark } from './Logo';

export default function Footer() {
  return (
    <footer className="oc-footer">
      <div className="oc-shell">
        <div className="oc-footer__cols">
          <div>
            <span className="oc-footer__brand">
              <LogoMark size={22} />
              <span>
                Officer<span style={{ color: 'var(--oc-green)' }}>Capital</span>
              </span>
            </span>
            <p style={{ fontSize: 13, lineHeight: 1.6, maxWidth: 280, color: '#888880' }}>
              A private marketplace connecting security guard companies with the capital they need —
              financing, investors, and acquirers.
            </p>
          </div>

          <div>
            <div className="oc-footer__col-label">For owners</div>
            <Link to="/financing"  className="oc-footer__link">Financing</Link>
            <Link to="/investors"  className="oc-footer__link">Investors</Link>
            <Link to="/sell"       className="oc-footer__link">Sell your company</Link>
          </div>

          <div>
            <div className="oc-footer__col-label">For partners</div>
            <Link to="/partners" className="oc-footer__link">For lenders</Link>
            <Link to="/partners" className="oc-footer__link">For investors</Link>
            <Link to="/partners" className="oc-footer__link">For acquirers</Link>
          </div>

          <div>
            <div className="oc-footer__col-label">Company</div>
            <Link to="/how-it-works" className="oc-footer__link">How it works</Link>
            <Link to="/pricing"      className="oc-footer__link">Pricing</Link>
            <Link to="/about"        className="oc-footer__link">About</Link>
            <a href="https://officerapps.com" className="oc-footer__link">OfficerApps</a>
          </div>
        </div>

        <div className="oc-footer__bottom">
          <span>© {new Date().getFullYear()} OfficerCapital. All rights reserved.</span>
          <span>
            <Link to="/privacy"  className="oc-footer__link" style={{ display: 'inline', marginRight: 16 }}>Privacy</Link>
            <Link to="/terms"    className="oc-footer__link" style={{ display: 'inline', marginRight: 16 }}>Terms</Link>
            <Link to="/security" className="oc-footer__link" style={{ display: 'inline' }}>Security</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
